/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ForecastPayload = {
    timeseries: Array<number>;
    exogenous_train: Array<number> | null;
    exogenous_pred: Array<number> | null;
    task: ForecastPayload.task;
    predictions?: number;
};
export namespace ForecastPayload {
    export enum task {
        SUPPLY = 'supply',
        DEMAND = 'demand',
    }
}

